// src/components/admin/AdminConfiguracion.js
import React, { useState, useEffect } from 'react';
import { listarConfiguraciones, actualizarConfiguracion } from '../../services/api';

const AdminConfiguracion = () => {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  // Lista de configuraciones que NO queremos mostrar (las que ya están en Límites Beta)
  const CONFIG_EXCLUIDAS = [
    'limite_imagenes_beta_default',
    'limite_texto_beta_default'
  ];

  useEffect(() => {
    cargarConfiguraciones();
  }, []);

  const cargarConfiguraciones = async () => {
    setLoading(true);
    try {
      const response = await listarConfiguraciones();
      // Filtrar para excluir las configuraciones de límites beta
      const configsFiltradas = response.data.configuraciones.filter(
        config => !CONFIG_EXCLUIDAS.includes(config.clave)
      );
      setConfigs(configsFiltradas);
    } catch (error) {
      console.error('Error cargando configuraciones:', error);
      setMensaje({ type: 'error', text: 'Error al cargar configuraciones' });
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (clave, valorActual) => {
    const nuevoValor = valorActual === 'true' ? 'false' : 'true';
    try {
      await actualizarConfiguracion(clave, nuevoValor);
      setMensaje({ type: 'success', text: 'Configuración actualizada' });
      cargarConfiguraciones();
      setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
    } catch (error) {
      setMensaje({ type: 'error', text: 'Error al actualizar' });
    }
  };

  if (loading) return <div className="loading">Cargando configuraciones...</div>;

  return (
    <div className="admin-configuracion">
      <h2>⚙️ Configuración del Sistema</h2>
      
      {mensaje.text && (
        <div className={`mensaje ${mensaje.type}`}>{mensaje.text}</div>
      )}

      <div className="config-grid">
        {configs.map(config => (
          <div key={config.id} className="config-card">
            <div className="config-info">
              <h3>{config.clave.replace(/_/g, ' ')}</h3>
              <p>{config.descripcion}</p>
            </div>
            <div className="config-control">
              {config.tipo === 'boolean' ? (
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={config.valor === 'true'}
                    onChange={() => handleToggle(config.clave, config.valor)}
                  />
                  <span className="slider"></span>
                </label>
              ) : (
                <span className="config-valor">{config.valor}</span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="info-box">
        <h4>ℹ️ Configuración General</h4>
        <p>Los límites beta se configuran en la sección "Límites Beta"</p>
      </div>
    </div>
  );
};

export default AdminConfiguracion;